import './HeaderLoadingState.scss';

import React from 'react';

const HeaderLoadingState = () => (
  <div className="header-loading">
    <div className="container h-100">
      <div className="header-content">
        <div className="skeleton-wrapper">
          <div className="skeleton-logo" />
        </div>

        <div className="nav-items">
          <div className="skeleton-wrapper">
            <div className="skeleton-nav-item" />
          </div>
          <div className="skeleton-wrapper">
            <div className="skeleton-nav-item" />
          </div>
          <div className="skeleton-wrapper">
            <div className="skeleton-nav-item" />
          </div>
          <div className="skeleton-wrapper">
            <div className="skeleton-nav-item" />
          </div>
        </div>

        <div className="user-menu">
          <div className="skeleton-wrapper">
            <div className="skeleton-avatar" />
          </div>
          <div className="skeleton-wrapper">
            <div className="skeleton-nav-item" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HeaderLoadingState;
